module.exports = __webpack_public_path__ + "static/media/HelveticaNeueThin.78c28465.ttf";